<template>
  <div class="container-div" v-if="selectedPackage">
    <table>
      <thead>
        <tr class="main-row">
          <th
            class="sub-title prod-title"
            style="font-size: 16px; text-align: left"
          >
            Produkt:
          </th>
          <th
            class="sub-title"
            style="min-width: 15%; font-size: 16px; text-align: left"
          >
            Ilość:
          </th>
          <th
            class="sub-title"
            style="min-width: 15%; font-size: 16px; text-align: right"
          >
            Cena:
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="content">
          <td class="prod-info">
            <mini-package :pack="selectedPackage" />
            <!-- <div
              class="background"
              v-if="selectedPackage && selectedPackage.name"
            >
              <span class="uppercase">{{ selectedPackage.name }} </span><br />
            </div> -->
            <div
              class="details"
              :style="
                !selectedPackage || !selectedPackage.name
                  ? 'padding-left: 20px;'
                  : ''
              "
              style="color: #8b857d"
            >
              <h4
                class="sub-title"
                style="font-size: 16px; text-align: left"
                v-if="
                  selectedPackage &&
                  selectedPackage.name &&
                  (!packageItem || routeName !== 'Payment')
                "
              >
                {{ selectedPackage.numberOfDays ? "Subskrypcja" : "" }}
                {{ selectedPackage.name }}
              </h4>
              <h4
                class="sub-title"
                style="font-size: 16px"
                v-if="packageItem && routeName === 'Payment'"
              >
                {{
                  isPackage24h
                    ? "Nagranie z zajęć ZOOM "
                    : "Zajęcia na żywo ZOOM"
                }}
              </h4>

              <h4 style="margin-left: 10px" v-if="!isCoursesTicket">
                <span
                  class="sub-title"
                  style="font-size: 14px"
                  v-if="selectedPackage.numberOfDays"
                  >WAŻNA DO:</span
                >
                <span v-else class="sub-title" style="font-size: 14px"
                  >DATA:</span
                >
                <span class="coloring-grey" style="font-size: 14px">
                  {{ getExpirationDate(selectedPackage.numberOfDays) }}</span
                >
              </h4>
              <h4 v-if="isCoursesTicket">
                {{
                  selectedPackage.type === "STANDARD"
                    ? "Karnet"
                    : "Karnet dla początkujących"
                }}
                - {{ selectedPackage.description }}
              </h4>
              <h4 v-if="isPackage24h" style="color: #c3a1a1">
                Nagranie otrzymasz po zakończeniu zajęć, nagranie ważne 24h
              </h4>
            </div>
          </td>

          <td style="min-width: 15%; font-size: 24px" class="coloring-grey">
            1
          </td>
          <td style="min-width: 15%; text-align: right; font-size: 16px">
            <!-- <span
              class="coloring-grey"
              v-if="selectedPackage.priceBeforeDiscount"
            >
              <span
                v-if="selectedPackage.priceBeforeDiscount.split('.')[1] == '00'"
                >{{
                  selectedPackage.priceBeforeDiscount.substring(
                    0,
                    selectedPackage.priceBeforeDiscount.length - 3
                  )
                }}</span
              >
              <span v-else>{{ selectedPackage.priceBeforeDiscount }}</span>
              zł</span
            > -->

            <span class="coloring-grey">
              <span v-if="selectedPackage.price.split('.')[1] == '00'">{{
                selectedPackage.price.substring(
                  0,
                  selectedPackage.price.length - 3
                )
              }}</span>
              <span v-else>{{ selectedPackage.price }}</span> zł</span
            >
          </td>
        </tr>
      </tbody>

      <div
        class="includings"
        v-if="!isCoursesTicket && (!packageItem || routeName !== 'Payment')"
      >
        <div
          @click="showWhatPackageIncludes = !showWhatPackageIncludes"
          class=""
          style="display: flex; justify-content: space-between"
        >
          <h5>Pakiet zawiera:</h5>
          <svg
            :style="showWhatPackageIncludes ? 'transform: rotate(180deg);' : ''"
            style="transition: all 0.3s"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.693 1.00168L11.5241 22.2142"
              stroke="#6D6963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.2148 11.6924L11.5241 22.2142L1.00231 11.5235"
              stroke="#6D6963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <ul v-if="showWhatPackageIncludes">
          <li
            :key="`${item}_${index}`"
            v-for="(item, index) in timePackagesItemsNames"
          >
            <span class="size-up">{{ item }} </span>
          </li>
        </ul>
      </div>
    </table>
  </div>
</template>

<script>
import moment from "moment";
import MiniPackage from "./MiniPackage.vue";
export default {
  components: { MiniPackage },
  name: "PurchaseSumUp",
  props: {
    isCoursesTicket: Boolean,
    selectedPackage: Object,
    timePackagesItemsNames: Array,
    activeSubscription: Object,
    activeSubscriptionExtended: Object,
    activeSubscriptionForBeginners: Object,
    isExtendedSubscription: Boolean,
  },
  data: () => ({
    showWhatPackageIncludes: false,
  }),
  correctTyping(numberOfDays) {
    if (numberOfDays / 31 === 1) {
      return numberOfDays / 31 + " miesiąc";
    } else if (numberOfDays / 31 > 1 && numberOfDays / 31 < 5) {
      return numberOfDays / 31 + " miesiące";
    } else {
      return numberOfDays / 31 + " miesięcy";
    }
  },

  methods: {
    getExpirationDate(numberOfDays) {
      if (this.packageItem && this.routeName === "Payment") {
        return this.packageItem.date;
      } else {
        const activeSubscription = this.activeSubscription;
        const activeSubscriptionExtended = this.activeSubscriptionExtended;
        if (
          this.selectedPackage &&
          this.selectedPackage.type === "FOR-BEGINNERS" &&
          this.activeSubscriptionForBeginners &&
          this.activeSubscriptionForBeginners.expiration_time
        ) {
          const subscriptionDate = moment(
            this.activeSubscriptionForBeginners.expiration_time
          );
          const newExpirationDate = moment().add(numberOfDays, "days");
          newExpirationDate.add(subscriptionDate.diff(moment()));
          return newExpirationDate.format("DD.MM.YYYY");
        } else if (
          !this.isExtendedSubscription &&
          activeSubscription &&
          (!this.selectedPackage || !this.selectedPackage.type)
        ) {
          const subscriptionDate = moment(activeSubscription.expiration_time);
          const newExpirationDate = moment().add(numberOfDays, "days");
          newExpirationDate.add(subscriptionDate.diff(moment()));
          return newExpirationDate.format("DD.MM.YYYY");
        }
        if (this.isExtendedSubscription && activeSubscriptionExtended) {
          const subscriptionDate = moment(
            activeSubscriptionExtended.expiration_time
          );
          const newExpirationDate = moment().add(numberOfDays, "days");
          newExpirationDate.add(subscriptionDate.diff(moment()));
          return newExpirationDate.format("DD.MM.YYYY");
        }
        return moment().add(numberOfDays, "days").format("DD.MM.YYYY");
      }
    },
    correctTyping(numberOfDays) {
      if (numberOfDays / 31 === 1) {
        return numberOfDays / 31 + " miesiąc";
      } else if (numberOfDays / 31 > 1 && numberOfDays / 31 < 5) {
        return numberOfDays / 31 + " miesiące";
      } else {
        return numberOfDays / 31 + " miesięcy";
      }
    },
  },

  computed: {
    timePackageItems() {
      return this.$store.getters["timePackages/getTimePackageItems"];
    },
    packageItem() {
      return this.$store.getters["packages/getPackage"];
    },
    routeName() {
      return this.$route.name;
    },
    isPackage24h() {
      return this.$route.query.recording;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Poppins:wght@300;400;600;700&family=Raleway:wght@400;500&family=Roboto:wght@300;400;500;700&display=swap");
* {
  font-family: "Inter", sans-serif;
}

.container-div {
  display: flex;
  flex-direction: column;
  padding: 40px 70px;
}
/* HEADER */
h1 {
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 10px;
}
/* CATEGORY NAMES */
h5 {
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.8rem;
  color: #666666;
}
/* FIRST SECTION POSITIONING */
.main-row,
.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}
.ilosc {
  padding-right: 50px;
  justify-content: center;
}
.uppercase {
  text-transform: uppercase;
}

.prod-info {
  display: flex;
  text-align: left;
  min-width: 70%;
}
.prod-title {
  min-width: 70%;
}
/* BTN STYLING */
.background {
  padding: 40px 25px;
  font-weight: 400;
  line-height: 1rem;
  font-size: 1.2rem;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  border-radius: 5px;
  color: #fff;
  text-align: center;
  transition: all 0.3s ease;
  font-weight: 500;
}

.background:hover {
  transform: translateY(-5px);
}
.btn-under {
  font-size: 0.7rem;
  font-weight: 400;
}
/* DETAILS STYLING */
.details {
  padding: 10px 20px;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.details h4 {
  margin-bottom: 10px;
  font-weight: 500;
}

/* BORDERS */
.content {
  padding-bottom: 20px;
}
/* LIST ITEM STYLING */
/* RESIZING THE DOTS */
ul li {
  font-size: 0.4rem;
  padding: 5px 0;
  text-align: left;
}
.size-up {
  font-size: 14px;
  color: #6d6963;
}

/* BORDER UNDER THE ARRAY OF PROMOTIONS*/
.includings {
  padding-bottom: 10px;
  margin-top: 1rem;
  cursor: pointer;
  border-bottom: 1px solid #6d6963;
}
.includings h5 {
  font-size: 20px;
  color: #6d6963;
}

/* LOGO POSITIONING */
.logo-pic {
  width: 70%;
}
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}
.text {
  width: 30%;
  padding-bottom: 60px;
}
.padd {
  padding-left: 50px;
}

/* SPAN COLORIZING*/
.coloring {
  color: #df2c26;
}
.coloring-grey {
  color: #54514c;
}

.prod-info .uppercase {
  font-size: 0.7rem;
}
/* MEDIA QUERIES */
@media screen and (max-width: 1300px) {
  .container-div {
    padding: 40px 35px;
  }
}
@media screen and (max-width: 1140px) {
  .container-div {
    padding: 0px 10px;
  }
}
@media screen and (max-width: 1000px) {
  .container-div {
    padding: 0px 20px;
  }
  .logo-pic {
    width: 90%;
  }
  .text {
    width: 50%;
  }
}

@media screen and (max-width: 950px) {
  .prod-info .background {
    display: none;
  }
  .prod-info {
    flex-direction: column;
    min-width: 50%;
  }
  .prod-title {
    min-width: 50%;
  }

  .details {
    padding: 0;
  }
  .container-div {
    padding: 0px 20px;
  }
}
@media screen and (max-width: 400px) {
  .main-row h5 {
    font-size: 0.6rem;
  }
  .padd {
    padding-left: 0px;
  }
  .prod-info {
    flex-direction: column;
  }
  .background {
    padding: 25px 0px;
  }
  .ilosc {
    padding-right: 0px;
    padding-left: 30px;
  }
}
</style>
